let { defaultState } = require('./state')

export default {
    reset: (state) => {
        Object.assign(state, defaultState())
    },
    set: (state, payload) => {
        Object.assign(state, payload)
    }
}
